module.exports = __webpack_public_path__ + "assets/pressure-reducing-valve.6975949d.svg";